var user = { key: 'guest-user-' + Math.floor(Math.random() * 101), "anonymous": true }
if (window.user_profile && window.user_profile.email) {
    user = {
        key: window.user_profile.email,
        name: window.user_profile.first_name + ' ' +  window.user_profile.last_name, 
        email: window.user_profile.email
    }
}
var hh_subscription_integration_enabled = 'homework-help-subscription-enabled'
var hh_subscription_integration_nz_enabled = 'homework-help-nz-subs-enabled'
var ecommerce_header_and_search = 'e-commerce-header-and-search'
var ecommerce_no_results_page = 'e-commerce-no-results-page'
var launchDarklyClientId = "5e8587929e80da08315d5525"
if (isProduction) {
    launchDarklyClientId = theme.settings.launchDarklyClientId
}

window.launchDarklyClient = LDClient.initialize(launchDarklyClientId, user);
launchDarklyClient.on('ready', function() {
    window.launchDarklyIsReady = true
    var ldClientFlags = launchDarklyClient.allFlags()

    $.getJSON('https://api.ipify.org?format=jsonp&callback=?').done(function(data) {
        if (data.ip === '203.206.236.68') { // Office IP
            launchDarklyClient.identify({
                ip: data.ip,
                key: 'zookal-office-user',
                email: 'admin-office@zookal.com'
            })
        }
        if (data.ip === '13.55.193.7') { // VPN IP
            launchDarklyClient.identify({
                ip: data.ip,
                key: 'zookal-vpn-user',
                email: 'admin-vpn@zookal.com'
            })
        }
    });
})
launchDarklyClient.on('change', (changes) => {
    var flattened = {}
    for (var key in changes) {
        var flagKey = key
        flattened[flagKey] = changes[key].current
    }
})
